import tw, { styled, theme } from 'twin.macro'
import LayoutContent from '@components/LayoutContent'

const TagStyle = {
  Layout: styled(LayoutContent)`
    ${tw`bg-white`}
    padding-bottom: 44px;
    @media (min-width: ${theme`screens.md`}) {
      padding-bottom: 111px;
    }
  `,
  Header: styled.h1`
    ${tw`text-gray-800`}
    width: 100%;
    font-size: 16px;
    line-height: 155%;
    letter-spacing: 0.25px;
    text-align: center;
    margin-top: 20px;
    @media (min-width: ${theme`screens.md`}) {
      font-size: 18px;
      line-height: 28px;
      margin-top: 40px;
    }
    .tag-name {
      font-weight: 600;
      font-size: 24px;
      margin-bottom: 12px;
      display: block;
      @media (min-width: ${theme`screens.md`}) {
        font-size: 28px;
        line-height: 38px;
      }
    }
  `,
  Container: styled.div`
    position: relative;
    width: 100%;
    /* 100vh - 開啟 app 提示高度 - header 高度 */
    min-height: calc(100vh - 62px - 64px);
    padding: 0 16px;
    margin: 0 auto;
    @media (min-width: ${theme`screens.md`}) {
      position: relative;
      width: 768px;
      /* 100vh - 廣告高度 + header 高度 */
      min-height: calc(100vh - 260px + 80px);
      margin: 0 auto;
      padding: 0;
    }
  `,
  CardWrapper: styled.div`
    width: 100%;
    box-sizing: border-box;
    @media (min-width: ${theme`screens.md`}) {
      width: 368px;
    }
  `,
  ResultContainer: styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    @media (min-width: ${theme`screens.md`}) {
      margin-top: 40px;
    }
  `,
  EmptyResultContainer: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 68px 0;
    font-size: 16px;
    ${tw`text-black`}
    > svg {
      margin-bottom: 0;
      width: 200px;
    }
    @media (min-width: ${theme`screens.md`}) {
      padding: 75px 0;
      > svg {
        margin-bottom: 42px;
        width: auto;
      }
    }
  `,
  Footer: styled.section`
    margin-top: 0;
    @media (min-width: ${theme`screens.md`}) {
      margin-top: 13px;
    }
  `,
}
export default TagStyle
